import { fromPairs, map, compose, tail, head, toPairs, mergeAll, toUpper } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import powerpointReplace from '../../modules/powerpointReplace';
import { XTNA } from '../xtna';
import utils from '../../modules/utils';

let FileSaver = null;

export default class XTNAReportGenerator extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }
  componentDidMount() {
    if (FileSaver === null) {
      FileSaver = require('browser-filesaver');
    }
  }
  render() {
    return (
      <form style={{ marginBottom: '10px' }}>
        <input type='button' className='btn btn-success' onClick={this.export} value='Reporte XTNA' disabled={!this.props.valid} />
      </form>
    );
  }
  unaccent(text) {
    text = text.replace(/á/g, 'a');
    text = text.replace(/é/g, 'e');
    text = text.replace(/í/g, 'i');
    text = text.replace(/ó/g, 'o');
    text = text.replace(/ú/g, 'u');
    text = text.replace(/ñ/g, 'n');
    text = text.replace(/Á/g, 'A');
    text = text.replace(/É/g, 'I');
    text = text.replace(/Í/g, 'E');
    text = text.replace(/Ó/g, 'O');
    text = text.replace(/Ú/g, 'U');
    text = text.replace(/Ñ/g, 'N');
    text = text.replace(/&/g, 'and');
    return text;
  }
  export() {
    //return Promise.resolve($.ajax({
      //url: this.props.consumeLicense,
      //method: 'POST',
      //}))
    
    return Promise.resolve(0)
    .then(() => this.props.licenseConsumed())
    .then(() => powerpointReplace(this.props.reportTemplateUrl, this.getReplacements(), [1, 10, 19]))
    .then((blob) => FileSaver.saveAs(blob, `Reporte XTNA - ${this.unaccent(this.props.personalData.name)}.pptx`));
  }
  getReplacements() {
    const changeResultValues = ['Factor consistente', 'Factor de cambio moderado', 'Factor de cambio intenso'];
    const descriptions = ['alta consistencia', 'consistencia promedio alto', 'baja consistencia', 'muy baja consistencia']
    
    const xtna = fromPairs(map((prop) => [prop, parseInt(this.props.xtna[prop])], XTNA.props()));
    const personal = this.props.personalData;
    const results = XTNA.getResults(xtna);

    const mapChangeToResult = (change) => changeResultValues[(change >= 2) + (change >= 4)];
    const changeResults = fromPairs(map(compose((change) =>
      [`${tail(head(change))}_CHANGE_RESULT`, mapChangeToResult(tail(change))]), toPairs(results.changes)));

    personal.company = this.unaccent(personal.company);

    const textReplacements = mergeAll([{
        name: personal.name,
        NAME: personal.name.toUpperCase(),
        COMPANY: personal.company,
        DATE: personal.date.format('DD MMMM YYYY'),
        company: personal.company,
        date: personal.date.format('DD/MM/YYYY'),
        age: personal.age + ' años',
        NPROFILE: results.NProfile.join(' - '),
        APROFILE: results.AProfile.join(' - '),
        CHANGE: results.change,
        CONSISTENCY: (results.consistency !== 1 ? ' ' : '') + utils.formatPercentage(results.consistency)
      },
      xtna,
      fromPairs(map(map(compose(toUpper, (x) => x.toString())), toPairs(results.derivedProperties))),
      fromPairs(toPairs(results.changes).map((change) => [toUpper(head(change)), tail(change)])),
      changeResults
    ]);

    const index = (results.consistency < .75) + (results.consistency < .60) + (results.consistency < .40);
    textReplacements.CONSISTENCY_RESULT = `${utils.formatPercentage(results.consistency)} ${descriptions[index]}`

    const canvasArray = $('canvas#' + this.props.chartsIds.xtna);
    if (!canvasArray.length) {
      throw new Error('Canvas with id: ' + this.props.chartsIds.xtna + ' id not mounted.');
    }

    const canvas2Array = $('canvas#' + this.props.chartsIds.xtnaTrabajo);
    if (!canvas2Array.length) {
      throw new Error('Canvas with id: ' + this.props.chartsIds.xtnaTrabajo + ' id not mounted.');
    }

    return {
      text: textReplacements,
      images: {
        'image13.png': head(canvasArray).toDataURL().split(',')[1],
        'image38.png': head(canvas2Array).toDataURL().split(',')[1]
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/reports/XTNAReportGenerator.jsx